import { render } from "./index2.vue?vue&type=template&id=7736f5d4&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"

import "./index2.vue?vue&type=style&index=0&id=7736f5d4&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7736f5d4"]])

export default __exports__